import { combineReducers } from 'redux'
import { Record } from 'immutable'
import * as actions from './actions'

const p2pHitsState = new Record({
  numberOfHitsShown: 0,
  lastSearchUrl: ''
})

const p2pHits = (state = p2pHitsState(), { type, numberOfHitsShown, lastSearchUrl }) => {
  switch (type) {
    case actions.SET_NUMBER_OF_P2P_HITS_SHOWN:
      return state.set('numberOfHitsShown', numberOfHitsShown)
    case actions.NEW_P2P_SEARCH:
      return state.set('numberOfHitsShown', numberOfHitsShown).set('lastSearchUrl', lastSearchUrl)
    default:
      return state
  }
}

const cookieSettingsModalOpen = (state = false, { type, value }) => {
  switch (type) {
    case actions.SET_COOKIE_SETTINGS_MODAL_OPEN:
      return value
    default:
      return state
  }
}

export default combineReducers({
  p2pHits,
  cookieSettingsModalOpen
})
